import React from "react";
import { Box } from "@mui/material";
import { Button, InfoBanner, useToast } from "@foundit/ui-library";
import { extractDomain } from "../../utils/helpers";
import { useTopUpMutation } from "../../redux/services/campaignListingService";
import { BannerAlert } from "../../constants/icons/BannerAlert";

interface IProps {
  children?: React.ReactNode;
  cta?: string;
  bannerRef: any;
  styles?: React.CSSProperties;
}

const Banner: React.FC<IProps> = ({ children, cta, bannerRef, styles }) => {
  const [showBanner, setShowBanner] = React.useState(true);
  const [triggerTopUp, { isLoading: triggerTopUpLoading }] = useTopUpMutation();
  const { showToast } = useToast();

  const handleCloseBanner = () => {
    setShowBanner(false);
  };

  const handleCtaClick = () => {
    const domain = extractDomain();
    if (cta === "Review limit") {
      window.open(`${domain}/edge/reports`, "_blank");
    } else {
      triggerTopUp({
        type: "Outreach",
        outreachNudge: bannerRef?.current?.innerText || "",
      })
        ?.unwrap()
        .then(() => {
          showToast({
            message: "Your request has been submitted.",
            type: "success",
            position: "bottom-left",
          });
        })
        .catch(() => {
          showToast({
            message: "Something went wrong.",
            type: "error",
            position: "bottom-left",
          });
        });
    }
  };

  return (
    <Box
      sx={{
        padding: "20px 40px 0px",
        maxWidth: "1440px",
        boxSizing: "border-box",
        margin: "0px auto",
        width: "100%",
        ...styles,
      }}
    >
      <InfoBanner isOpen={showBanner} onClose={handleCloseBanner}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            fontSize: "14px",
          }}
        >
          <BannerAlert />

          {children}

          <Button
            loading={triggerTopUpLoading}
            type="contained_grey"
            size="small"
            onClick={handleCtaClick}
          >
            {cta}
          </Button>
        </Box>
      </InfoBanner>
    </Box>
  );
};

export default Banner;
